import useAPI from '@/hooks/useAPI';
import EpisodeOfCareRepository from '@/repositories/EpisodeOfCareRepository/EpisodeOfCareRepository';

const useGraduationReasons = (enabled = true) => {
  const episodeOfCareRepository = EpisodeOfCareRepository();

  return useAPI({
    queryKey: ['getGraduationReasons'],
    queryFn: async () => {
      return await episodeOfCareRepository.getGraduationReasons();
    },
    enabled
  });
};

export default useGraduationReasons;
